import React, { ReactElement, Ref } from 'react';

import { MultiAutocompleteControlProps } from './MultiAutocompleteControl';
import MultiAutocompleteTokenControl from './MultiAutocompleteTokenControl';
import ControlContainer from '../../layout/Control/ControlContainer';
import { GenericItem } from '../../types';

type SingleAutocompleteTokenControlProps<TItem extends GenericItem> = Omit<
  MultiAutocompleteControlProps<TItem>,
  'selectedItems' | 'removeSelectedItem' | 'getSelectedItemProps'
> & {
  selectedItem: TItem | null;
  selectItem?: (item: TItem | null) => void;
};

const SingleAutocompleteTokenControlWrapped = <TItem extends GenericItem>(
  {
    selectItem,
    selectedItem,
    ...props
  }: SingleAutocompleteTokenControlProps<TItem>,
  ref: Ref<HTMLDivElement>,
) => (
  <MultiAutocompleteTokenControl<TItem>
    ref={ref}
    getSelectedItemProps={() => ({})}
    removeSelectedItem={() => {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore https://github.com/downshift-js/downshift/pull/1334
      selectItem?.(null);
    }}
    selectedItems={selectedItem ? [selectedItem] : null}
    renderItems={props.isOpen ? () => null : props.renderItems}
    {...props}
  />
);

const SingleAutocompleteTokenControl = React.forwardRef(
  SingleAutocompleteTokenControlWrapped,
);

SingleAutocompleteTokenControl.displayName = 'SingleAutocompleteTokenControl';

SingleAutocompleteTokenControl.propTypes = {
  ...ControlContainer.propTypes,
};

export default SingleAutocompleteTokenControl as <T extends GenericItem>(
  p: SingleAutocompleteTokenControlProps<T> & {
    ref?: Ref<HTMLDivElement>;
  },
) => ReactElement;
